import Head from 'next/head';
import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { type FullBoatSearchDetail } from 'src/common/types/api/v4/boats/search';
import { PATHS } from 'src/common/constants';
import DescriptionMetaTag from 'src/common/components/MetaTags/DescriptionMetaTag';
import OpenGraphMetaTags from 'src/common/components/MetaTags/OpenGraphMetaTags';

export type MetaFieldsProps = {
  listing: FullBoatSearchDetail;
};

/** Minimally branded for book-now-direct */
const MetaFields: FC<MetaFieldsProps> = ({
  listing,
}) => {
  const [t] = useTranslation('book-now-direct');

  return (
    <>
      <Head>
        <title>
          {t('title')}
        </title>
      </Head>
      <DescriptionMetaTag content={t('meta-description')} />
      <OpenGraphMetaTags
        canonicalPath={`${PATHS.LISTING}${listing.id}${PATHS.BOOK_NOW_DIRECT}`}
        title={listing.title ?? listing.headline}
        description={t('meta-description')}
        imageUrl={listing.photo_url}
        noIndex
      />
    </>
  );
};

export default MetaFields;
